import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { EbookMockup } from './components/EbookMockup';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initMetaPixel, trackCustomEvent } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel on mount
    initMetaPixel();
    // Track all clicks on the page
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const clickedElement = target.closest('a, button') as HTMLElement | null;
      if (clickedElement) {
        const text = clickedElement.textContent?.trim() || 'unknown';
        const tagName = clickedElement.tagName.toLowerCase();
        const href = clickedElement.getAttribute('href') || '';
        trackCustomEvent('ClickEvent', {
          element_type: tagName,
          element_text: text.substring(0, 100),
          element_href: href,
          page_section: clickedElement.closest('section')?.id || 'header',
          timestamp: new Date().toISOString()
        });
      }
    };
    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, []);
  return <div className="min-h-screen bg-wellness-white font-sans text-wellness-dark overflow-x-hidden selection:bg-wellness-sage/30 selection:text-wellness-dark" data-id="element-0">
      <StickyHeader data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <EbookMockup data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
      <WhatsAppButton data-id="element-11" />
    </div>;
}